import { Platform } from 'react-native';
import { WebFocusEvent, FocusEvent } from './types';

const isWeb = (_: FocusEvent): _ is WebFocusEvent => Platform.OS === 'web';

export const scrollIntoView = (event: FocusEvent) => {
    isWeb(event) && event.currentTarget.scrollIntoView({ block: 'center', behavior: 'smooth' });
};
